<template>
    <div class="overlay" :class="{active: this.$root.menu_active}">
        <div class="menu-trek">
            <img src="/wp-content/themes/dynacap/assets/img/menu-trek.png">
        </div>

        <div class="bg">
            <svg width="1500" height="1000" viewBox="0 0 1500 1000" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <path opacity="0.14" d="M-403.924 -414.311L960.144 373.235L-403.924 1160.78L-403.924 -414.311Z" :style="{fill: currentBg}"/>
                <path opacity="0.7" d="M-111.455 65.6893L1252.61 853.235L-111.455 1640.78L-111.455 65.6893Z" fill="#121212"/>
                <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="-39" y="108" width="731" height="840">
                <path d="M-38.3525 947.581V108.362L691.503 528.547L-38.3525 947.581Z" fill="#C4C4C4"/>
                </mask>
            </svg>
        </div>
        
        <!-- <div class="bg bg2"></div>
        <div class="bg" :style="{borderLeftColor: currentBg}"></div> -->
        <div class="grid-container text-center">
            <nav id="main-nav" v-if="menu">
                <ul>
                    <li v-for="item in menu" :key="item.ID">
                        <a class="bigtext" @mouseover="changeBg(item.bg)" :href="item.url" v-text="item.title"></a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>    
</template>

<script>
    export default {
        props: {
            menu: {
                default: []
            }
        },
        data() {
            return {
                currentBg: '#000fff'
            }
        },
        methods: {
            changeBg(bg) {
                this.currentBg = bg;
            }
        },
        mounted() {
            if(this.menu) {
                this.currentBg = this.menu[0].bg;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .overlay {
        position: fixed;
        top: 0px; left: 0px; width: 100%; height: 100%;
        background: $black;
        z-index: 98;
        opacity: 0;
        visibility: hidden;
        transition: opacity .5s ease, visibility 0s .5s ease;
        display: flex;
        flex-flow: wrap row;
        align-items: center;

        .bg {
            position: absolute;
            opacity: 1;
            top: 0; left: 0;
            z-index: 1;

            svg path {
                transition: .4s ease;
            }

        }

        .menu-trek {
            position: absolute;
            z-index: 2;
            top: 50%;
            transform: translateY(-50%);
        }

        .grid-container {
            width: 100%;
        }

        &.active {
            opacity: 1;
            visibility: visible;
            transition: opacity .5s ease;
        }

        #main-nav {
            position: relative;
            z-index: 2;

            ul {
                list-style: none;
                padding: 0px;
                margin: 0px;
                transition: opacity .5s ease;

                &:hover {
                    li a {
                        opacity: 0.3;
                    }
                }

                li {
                    margin: 2rem 0;

                    a {
                        transition: opacity .5s ease;
                        &:hover {
                            opacity: 1;
                            color: white;
                        }

                    }
                }

                .bigtext {
                    font-size: 7vw;
                    text-decoration: none;
                    
                }

            }
        }
    }
</style>